import { render } from "./LabManagement.vue?vue&type=template&id=4ba3dfc8&scoped=true"
import script from "./LabManagement.vue?vue&type=script&lang=js"
export * from "./LabManagement.vue?vue&type=script&lang=js"

import "./LabManagement.vue?vue&type=style&index=0&id=4ba3dfc8&lang=css"
import "./LabManagement.vue?vue&type=style&index=1&id=4ba3dfc8&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba3dfc8"]])

export default __exports__